import { createSlice } from "@reduxjs/toolkit";
import { defaultAddReducer, defaultSetReducer, defaultUpdateReducer, defaultRemoveReducer } from "./defaultReducer";

const initialState = {
  list: [],
};

const slice = createSlice({
  name: "groups",
  initialState,
  reducers: {
    // Give case reducers meaningful past-tense "event"-style names
    setGroupsReducer: defaultSetReducer,
    updateGroupReducer: defaultUpdateReducer,
    addGroupReducer: defaultAddReducer,
    removeGroupReducer: defaultRemoveReducer,
  },
});

// `createSlice` automatically generated action creators with these names.
// export them as named exports from this "slice" file
export const { setGroupsReducer, updateGroupReducer, addGroupReducer, removeGroupReducer } = slice.actions;

// Export the slice reducer as the default export
export default slice.reducer;
